import { render, staticRenderFns } from "./Budgets.vue?vue&type=template&id=28a34c99"
import script from "./Budgets.vue?vue&type=script&lang=js"
export * from "./Budgets.vue?vue&type=script&lang=js"
import style0 from "./Budgets.vue?vue&type=style&index=0&id=28a34c99&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports